import { render } from "./EmbeddedContent.vue?vue&type=template&id=3b57cfba&scoped=true"
import script from "./EmbeddedContent.vue?vue&type=script&lang=js"
export * from "./EmbeddedContent.vue?vue&type=script&lang=js"

import "./EmbeddedContent.vue?vue&type=style&index=0&id=3b57cfba&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b57cfba"]])

export default __exports__